import React, { useContext } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { AppContext } from '../../AppContext';
import { Actions } from '../../enums/ActionEnums';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Message: React.FunctionComponent = () => {
  const { state, dispatch } = useContext(AppContext);
  const handleClose = (_: unknown, reason: string) => {
    if (reason !== 'clickaway') {
      dispatch({ type: Actions.HideMessage });
    }
  };
  return (
    <Snackbar
      open={state.message.open}
      autoHideDuration={state.message.autoHide}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        id="alert-message"
        onClose={() => dispatch({ type: Actions.HideMessage })}
        severity={state.message.severity ?? 'success'}
        sx={{
          cursor: 'pointer'
        }}
      >
        {state.message.text}
      </Alert>
    </Snackbar>
  );
};

export default Message;
